module.exports = __webpack_public_path__ + "img/fbn-logo.410c129e.svg";